"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * keepkey-sdk-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypesFeaturesToJSON = exports.TypesFeaturesFromJSONTyped = exports.TypesFeaturesFromJSON = exports.instanceOfTypesFeatures = void 0;
const runtime_1 = require("../runtime");
const TypesFeaturesAutoLockDelayMs_1 = require("./TypesFeaturesAutoLockDelayMs");
const TypesFeaturesBootloaderHash_1 = require("./TypesFeaturesBootloaderHash");
const TypesFeaturesFirmwareHash_1 = require("./TypesFeaturesFirmwareHash");
const TypesFeaturesMajorVersion_1 = require("./TypesFeaturesMajorVersion");
const TypesFeaturesMinorVersion_1 = require("./TypesFeaturesMinorVersion");
const TypesFeaturesPatchVersion_1 = require("./TypesFeaturesPatchVersion");
const TypesFeaturesRevision_1 = require("./TypesFeaturesRevision");
const TypesPolicy_1 = require("./TypesPolicy");
/**
 * Check if a given object implements the TypesFeatures interface.
 */
function instanceOfTypesFeatures(value) {
    let isInstance = true;
    return isInstance;
}
exports.instanceOfTypesFeatures = instanceOfTypesFeatures;
function TypesFeaturesFromJSON(json) {
    return TypesFeaturesFromJSONTyped(json, false);
}
exports.TypesFeaturesFromJSON = TypesFeaturesFromJSON;
function TypesFeaturesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'auto_lock_delay_ms': !(0, runtime_1.exists)(json, 'auto_lock_delay_ms') ? undefined : (0, TypesFeaturesAutoLockDelayMs_1.TypesFeaturesAutoLockDelayMsFromJSON)(json['auto_lock_delay_ms']),
        'wipe_code_protection': !(0, runtime_1.exists)(json, 'wipe_code_protection') ? undefined : json['wipe_code_protection'],
        'no_backup': !(0, runtime_1.exists)(json, 'no_backup') ? undefined : json['no_backup'],
        'firmware_hash': !(0, runtime_1.exists)(json, 'firmware_hash') ? undefined : (0, TypesFeaturesFirmwareHash_1.TypesFeaturesFirmwareHashFromJSON)(json['firmware_hash']),
        'firmware_variant': !(0, runtime_1.exists)(json, 'firmware_variant') ? undefined : json['firmware_variant'],
        'model': !(0, runtime_1.exists)(json, 'model') ? undefined : json['model'],
        'policies': !(0, runtime_1.exists)(json, 'policies') ? undefined : (json['policies'].map(TypesPolicy_1.TypesPolicyFromJSON)),
        'passphrase_cached': !(0, runtime_1.exists)(json, 'passphrase_cached') ? undefined : json['passphrase_cached'],
        'pin_cached': !(0, runtime_1.exists)(json, 'pin_cached') ? undefined : json['pin_cached'],
        'imported': !(0, runtime_1.exists)(json, 'imported') ? undefined : json['imported'],
        'bootloader_hash': !(0, runtime_1.exists)(json, 'bootloader_hash') ? undefined : (0, TypesFeaturesBootloaderHash_1.TypesFeaturesBootloaderHashFromJSON)(json['bootloader_hash']),
        'revision': !(0, runtime_1.exists)(json, 'revision') ? undefined : (0, TypesFeaturesRevision_1.TypesFeaturesRevisionFromJSON)(json['revision']),
        'initialized': !(0, runtime_1.exists)(json, 'initialized') ? undefined : json['initialized'],
        'label': !(0, runtime_1.exists)(json, 'label') ? undefined : json['label'],
        'language': !(0, runtime_1.exists)(json, 'language') ? undefined : json['language'],
        'passphrase_protection': !(0, runtime_1.exists)(json, 'passphrase_protection') ? undefined : json['passphrase_protection'],
        'pin_protection': !(0, runtime_1.exists)(json, 'pin_protection') ? undefined : json['pin_protection'],
        'device_id': !(0, runtime_1.exists)(json, 'device_id') ? undefined : json['device_id'],
        'bootloader_mode': !(0, runtime_1.exists)(json, 'bootloader_mode') ? undefined : json['bootloader_mode'],
        'patch_version': !(0, runtime_1.exists)(json, 'patch_version') ? undefined : (0, TypesFeaturesPatchVersion_1.TypesFeaturesPatchVersionFromJSON)(json['patch_version']),
        'minor_version': !(0, runtime_1.exists)(json, 'minor_version') ? undefined : (0, TypesFeaturesMinorVersion_1.TypesFeaturesMinorVersionFromJSON)(json['minor_version']),
        'major_version': !(0, runtime_1.exists)(json, 'major_version') ? undefined : (0, TypesFeaturesMajorVersion_1.TypesFeaturesMajorVersionFromJSON)(json['major_version']),
        'vendor': !(0, runtime_1.exists)(json, 'vendor') ? undefined : json['vendor'],
    };
}
exports.TypesFeaturesFromJSONTyped = TypesFeaturesFromJSONTyped;
function TypesFeaturesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'auto_lock_delay_ms': (0, TypesFeaturesAutoLockDelayMs_1.TypesFeaturesAutoLockDelayMsToJSON)(value.auto_lock_delay_ms),
        'wipe_code_protection': value.wipe_code_protection,
        'no_backup': value.no_backup,
        'firmware_hash': (0, TypesFeaturesFirmwareHash_1.TypesFeaturesFirmwareHashToJSON)(value.firmware_hash),
        'firmware_variant': value.firmware_variant,
        'model': value.model,
        'policies': value.policies === undefined ? undefined : (value.policies.map(TypesPolicy_1.TypesPolicyToJSON)),
        'passphrase_cached': value.passphrase_cached,
        'pin_cached': value.pin_cached,
        'imported': value.imported,
        'bootloader_hash': (0, TypesFeaturesBootloaderHash_1.TypesFeaturesBootloaderHashToJSON)(value.bootloader_hash),
        'revision': (0, TypesFeaturesRevision_1.TypesFeaturesRevisionToJSON)(value.revision),
        'initialized': value.initialized,
        'label': value.label,
        'language': value.language,
        'passphrase_protection': value.passphrase_protection,
        'pin_protection': value.pin_protection,
        'device_id': value.device_id,
        'bootloader_mode': value.bootloader_mode,
        'patch_version': (0, TypesFeaturesPatchVersion_1.TypesFeaturesPatchVersionToJSON)(value.patch_version),
        'minor_version': (0, TypesFeaturesMinorVersion_1.TypesFeaturesMinorVersionToJSON)(value.minor_version),
        'major_version': (0, TypesFeaturesMajorVersion_1.TypesFeaturesMajorVersionToJSON)(value.major_version),
        'vendor': value.vendor,
    };
}
exports.TypesFeaturesToJSON = TypesFeaturesToJSON;
